export default __webpack_public_path__ + "assets/img/welcome_splash.e6f4059078554d4d0ae2c436e99184a2.jpg";